
import { usePlanHooks } from './subscriptions/usePlans';
import { useUserSubscriptionHooks } from './subscriptions/useUserSubscriptions';
import { useFeaturesHooks } from './subscriptions/useFeatures';
import { useQuery } from '@tanstack/react-query';
import { fetchSubscriptionPlanById } from './subscriptions/usePlans';

// Main hook that combines all subscription-related hooks
export const useSubscriptions = () => {
  const planHooks = usePlanHooks();
  const userSubscriptionHooks = useUserSubscriptionHooks();
  const featureHooks = useFeaturesHooks();
  
  return {
    // Plan hooks
    ...planHooks,
    
    // User subscription hooks
    ...userSubscriptionHooks,
    
    // Feature hooks
    ...featureHooks,
    
    // Direct access to the subscription plan by ID query
    useSubscriptionPlanByIdQuery: (planId: string | undefined) => useQuery({
      queryKey: ['subscription-plan', planId],
      queryFn: () => fetchSubscriptionPlanById(planId!),
      enabled: !!planId
    })
  };
};

// Re-export types from the types file
export * from './subscriptions/types';
